import React, {useState, useMemo} from 'react'


const PurchaseContext = React.createContext()
PurchaseContext.displayName = 'PurchaseContext'

const PurchaseContextProvider = ({children}) => {
    const [stockList, setStockList] = useState([])
    const [deleteCount, setDeleteCount] = useState(0)
    const [purchaseItems, setPurchaseItems] = useState([])
    const [recipeData, setRecipeData] = useState([])
    const [updateReadTable, setUpdateReadTable] = useState(false)
    const [purchaseInfos, setPurchaseInfos] = useState({})
    const [supplierList, setSupplierList] = useState([])
    const [taxList, setTaxList] = useState([])

    const toggleTableUpdate = () => setUpdateReadTable(!updateReadTable)
    const calcPurchaseCurrencies = () => {
        const currencyObj = {
            "EUR": [],
            "TRY": [],
            "USD": []
        }

        purchaseItems.map(item => {
            if (item.selectedCurrency && item.selectedCurrency.length) {
                let total = item.quantity * (item.unitPrice || 0)
                if (item.discount) total -= total * item.discount / 100
                currencyObj[item.selectedCurrency].push(total)
            }
        })

        return currencyObj
    }
    const calcTotalForTaxAndCurrencies = () => {
        const crrObj = {
            "EUR": [],
            "TRY": [],
            "USD": []
        }

        Object.keys(memoizeCurrencyTotals).map(currencyKey => {
            const currencyTotal = memoizeCurrencyTotals[currencyKey].reduce((a, b) => a + b, 0)
            let currencyTax = 0

            if (currencyTotal) {
                taxList.map(item => {
                    if (item.taxName && item.taxRatio) {
                        currencyTax += (currencyTotal * item.taxRatio) / 100
                    }
                })
            }
            crrObj[currencyKey] = currencyTax + currencyTotal
        })
        return crrObj
    }
    const getTaxForEachCurrency = () => {
        const resultObj = {
            "EUR": [],
            "TRY": [],
            "USD": []
        }

        Object.keys(memoizeCurrencyTotals).map(currencyKey => {
            const currencyTotal = memoizeTaxCurrencyTotals[currencyKey]
            taxList.map(item => {
                const obj = {
                    key: item.taxName,
                    value: currencyTotal * (1 + (item.taxRatio / 100))
                }

                resultObj[currencyKey].push(obj)
            })

        })

        return resultObj
    }

    const memoizeCurrencyTotals = useMemo(() => calcPurchaseCurrencies(), [purchaseItems])
    const memoizeTaxCurrencyTotals = useMemo(() => calcTotalForTaxAndCurrencies(), [memoizeCurrencyTotals, taxList])
    const memoizeEachTaxValue = useMemo(() => getTaxForEachCurrency(), [memoizeTaxCurrencyTotals, taxList])

    const values = {
        purchaseItems: [purchaseItems, setPurchaseItems],
        updateDeleteCount: [deleteCount, setDeleteCount],
        shouldUpdateTable: [updateReadTable, setUpdateReadTable],
        updateDataTable: toggleTableUpdate,
        taxes: [taxList, setTaxList],
        recipes: [recipeData, setRecipeData],
        suppliers: [supplierList, setSupplierList],
        purchaseInfos: [purchaseInfos, setPurchaseInfos],
        stocks: [stockList, setStockList],
        memoizeCurrencyTotals: memoizeCurrencyTotals,
        memoizeTaxCurrencyTotals: memoizeTaxCurrencyTotals,
        getEachTaxValue: memoizeEachTaxValue
    }

    return (
        <PurchaseContext.Provider value={values}>
            {children}
        </PurchaseContext.Provider>
    )
}

export {PurchaseContextProvider, PurchaseContext}